import { forwardRef } from "react";
import SvgIcon from "@mui/material/SvgIcon";
import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCluster = forwardRef((props, ref) => {
	return React.createElement(SvgIcon, {
		...props,
		ref
	}, /* @__PURE__ */ _jsx("path", {
		d: "M16.5215 10.4112V4.87523C16.5214 4.7359 16.4825 4.59934 16.4092 4.48084C16.3359 4.36234 16.2311 4.26657 16.1065 4.20423L12.3565 2.32923C12.2524 2.27744 12.1377 2.25049 12.0215 2.25049C11.9052 2.25049 11.7906 2.27744 11.6865 2.32923L7.93648 4.20023C7.81173 4.26238 7.70679 4.35812 7.63347 4.47666C7.56016 4.5952 7.52137 4.73185 7.52148 4.87123V10.4072L12.0215 12.6572L16.5215 10.4112Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M12.0215 18.6611V12.6611L7.52148 10.4111L3.43648 12.4541C3.31173 12.5163 3.20679 12.612 3.13347 12.7306C3.06016 12.8491 3.02137 12.9858 3.02148 13.1251V18.2001C3.02137 18.3395 3.06016 18.4762 3.13347 18.5947C3.20679 18.7132 3.31173 18.809 3.43648 18.8711L7.18648 20.7461C7.29056 20.7979 7.40523 20.8249 7.52148 20.8249C7.63774 20.8249 7.75241 20.7979 7.85648 20.7461L12.0215 18.6611Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M20.6065 18.8691C20.7311 18.8068 20.8359 18.711 20.9092 18.5925C20.9825 18.474 21.0214 18.3375 21.0215 18.1981V13.1251C21.0214 12.9858 20.9825 12.8492 20.9092 12.7307C20.8359 12.6122 20.7311 12.5165 20.6065 12.4541L16.5215 10.4111L12.0215 12.6611V18.6611L16.1865 20.7441C16.2906 20.7959 16.4052 20.8229 16.5215 20.8229C16.6377 20.8229 16.7524 20.7959 16.8565 20.7441L20.6065 18.8691Z",
		stroke: "currentcolor",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round",
		fill: "none"
	}));
});
export default SvgCluster;
